<template>
    <div class="forgot-password-container">
        <img alt="Logo Delicorner" class="logo" src="/svg/logo--white.svg"/>

        <form class="forgot-password-box">
            <p class="forgot-password-message">
                Veuillez saisir l'adresse mail associée à votre compte pour réinitialiser votre mot de passe.
            </p>
            <div class="mb-4">
                <label class="block text-gray-700 text-sm font-bold mb-2"
                       for="email"></label>
                <input id="email"
                       v-model="email"
                       :disabled="loading"
                       required
                       class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                       placeholder="Email"
                       type="text"
                />
            </div>
            <div class="flex items-center justify-center">
                <button :disabled="loading" class="forgot-password-button" @click="submit">
                    <img alt="" class="buttonImg" src="/svg/lemon.svg"/>
                    <span class="textButton">GO!</span>
                </button>
            </div>
        </form>
    </div>
</template>

<script>
import {notifyRaw} from "@/helper";
import {api, API_ROUTES} from "@/Services/api.common.service";

export default {
    name: "ForgotPassword",
    data() {
        return {
            email: "",
            loading: false,
        };
    },
    methods: {
        async submit() {
            this.loading = true;
            const notify = notifyRaw.bind(this);

            if (this.email === "") {
                notify("Veuillez saisir une adresse mail", "error");
                this.loading = false;
                return;
            }

            try {
                await api().post(API_ROUTES.auth.forgotPassword, {
                    email: this.email,
                    resetPasswordUrl: `${window.location.origin}/resetPassword`,
                });
                notify(`Si un compte est rattaché à cette adresse (${this.email}), vous recevrez un mail pour réinitialiser votre mot de passe !`, "success");
                this.email = '';
            } catch (e) {
                notify("Une erreur est survenue", "error");
            }
            this.loading = false;
        },
    }
}
</script>

<style lang="css" scoped>
.forgot-password-button {
    cursor: pointer;
    position: relative;
}

.textButton {
    color: white;
    font-size: 24px;
    font-weight: bold;
    left: 50%;
    position: absolute;
    top: 50%;
    transform: translate(-56%, -20%);
}

.logo {
    height: 100%;
    margin-bottom: 50px;
    max-height: 250px;
}

.forgot-password-box {
    max-width: 400px;
    width: 50%;
}

input {
    background: white;
    font-size: 20px;
    line-height: 30px;
}

.forgot-password-message {
    text-align: center;
    font-weight: 500;
    color: white;
    font-size: 1.1rem;
}

.forgot-password-container {
    @apply mx-auto flex flex-col justify-center items-center h-screen bg-main;
    width: 100%;
}
</style>
